// CORE
import React, { Component } from 'react'

// MODULES
import { 
	ModuleOne, 
	ModuleFour,
	ModuleFive } from '../../../components/Modules'

// STYLES
import classes from '../layout.css'

class DentalImplant extends Component {
	render() {
		const { addToForm, consentForm } = this.props

		return (
			<form id={consentForm.formId} className={classes.Container}>
				<h2>{consentForm.formName}</h2>

				<ModuleOne
					addToForm={addToForm} 
					consentForm={consentForm} 
				/>
				<p><strong>Please initial each paragraph after reading. If you have any questions, please ask your doctor BEFORE initialing.</strong></p>
				<ModuleFour
					addToForm={addToForm}
					consentForm={consentForm} 
				/>
				<h3>CONSENT</h3>
				I understand that my doctor can’t promise that everything will be perfect. I have read and understand the above and give my consent to surgery. I have given a complete and truthful medical history, including all medicines, drug use, pregnancy, etc. I certify that I speak, read and write English. All of my questions have been answered before signing this form.
				<ModuleFive
					addToForm={addToForm} 
					consentForm={consentForm} 
				/>
			</form>
		)
	}
}

export default DentalImplant


// WEBPACK FOOTER //
// ./src/containers/FormLayout/Form/5.js